import { hasAllPurposesConsent } from "@escapio/shared/tracker/ConsentObserver";

export function setZone(zone) {
	hasAllPurposesConsent.then(() => {
		window.SDG?.Publisher.setZone(zone);
		/*
		 * All our slots are lazy, but we have to call `finalizeSlots` at some point.
		 * Usually this should happen once all the slots are registered.
		 * We don't know when this exactly happens.
		 * But since Stroer does support lazy slots, this should not be a big problem.
		 * Therefore we just call it when the zone is set.
		 */
		window.SDG?.Publisher.finalizeSlots();
	});
}

export function registerSlot(slotName, containerId) {
	return hasAllPurposesConsent.then(() =>
		window.SDG?.Publisher.registerSlot(slotName, containerId),
	);
}

export function loadSlot(slotName) {
	hasAllPurposesConsent.then(() => window.SDG?.Publisher.loadSlot(slotName));
}
